import Table from "@mui/material/Table";
import TableHead from "@mui/material/TableHead";
import TableBody from "@mui/material/TableBody";
import TableRow from "@mui/material/TableRow";
import TableCell from "@mui/material/TableCell";
import IconButton from "@mui/material/IconButton";
import Tooltip from "@mui/material/Tooltip";
import Chip from "@mui/material/Chip";
import Edit from "@mui/icons-material/Edit";
import { IfPermission } from "../../auth/IfPermission";
import type { RoleListItem } from "./useRoleList";

interface RoleDataGridProps {
  items: RoleListItem[];
  onEdit: (role: RoleListItem) => void;
}

export function RoleDataGrid({ items, onEdit }: RoleDataGridProps) {
  return (
    <Table>
      <TableHead>
        <TableRow>
          <TableCell>Название</TableCell>
          <TableCell align="right">Пермишенов</TableCell>
          <TableCell align="right">Уровень</TableCell>
          <TableCell align="right">Пользователей</TableCell>
          <TableCell>Тип</TableCell>
          <TableCell align="right">Действия</TableCell>
        </TableRow>
      </TableHead>
      <TableBody>
        {items.map((role) => (
          <TableRow key={role.id}>
            <TableCell>{role.name}</TableCell>
            <TableCell align="right">{role.permissions.length}</TableCell>
            <TableCell align="right">{role.level}</TableCell>
            <TableCell className="tabular-nums" align="right">{role.userCount}</TableCell>
            <TableCell>
              {role.type === "user" ? <Chip label="Пользовательская" size="small" /> : <Chip label="Системная" size="small" variant="outlined" />}
            </TableCell>
            <TableCell align="right">
              <IfPermission permission="roles.manage">
                <Tooltip title={role.type === "user" ? "Редактировать" : "Просмотр (системная роль)"}>
                  <IconButton aria-label={role.type === "user" ? "Редактировать" : "Просмотр"} onClick={() => onEdit(role)}>
                    <Edit />
                  </IconButton>
                </Tooltip>
              </IfPermission>
            </TableCell>
          </TableRow>
        ))}
      </TableBody>
    </Table>
  );
}
